import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import * as moment from "moment";
import { isApiResponse, isReportAccess, date_range_config, user_activities } from '../../helpers/utils.js';
import SettledUnsettledFilter from '../../filters/settled_unsettledFilter.jsx';
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from 'react-spinners';
import {confirmAlert} from 'react-confirm-alert';
import SingleCsvReportDownload from '../DownloadReport/SingleCsvReportDownload.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
import TxnIssuerFilter from '../../filters/TxnIssuerFilter.jsx';
import CityFilter from '../../filters/CityFilter.jsx';
import TxnTypeFilter from '../../filters/TxnTypeFilter1.jsx';
import SchemeFilter from '../../filters/SchemeFilter.jsx';
import CardTypeFilter from '../../filters/CardTypeFilter.jsx';
import HomeCurrencyFilter from '../../filters/HomeCurrencyFilter.jsx';
import TxnCurrencyFilter from '../../filters/TxnCurrencyFilter.jsx';
import IndustryCategoryFilter from '../../filters/IndustryCategoryFilter.jsx';
import PosbillFilter from '../../filters/PosbillFilter.jsx';
import PrimIdFilter from '../../filters/PrimIdFilter.jsx';
const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align: center;
`;
var date_config = date_range_config('1', '1', '2020-02-01','1');
var date_config1 = date_range_config('0', '0', '2020-02-01','0');
var DccTraTable = '';

class DccTransactionReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            issuerBankIds:'',
            cityIds:'',
            loading:false,
            is_void: 1,
            cardGradeIDs:'',
            schemeIDs:'',
            cardTypeIDs:'',
            txnissuerIDs:'',
            tenderModeIDs:'',
            txnTypeIDs: ['SALE'],
            ciutidIds: '',
            slipData:'',
            isSettledIDs: '',
            is_fallback: 0,
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            merchant_sku: 0,
            productTypeIDs: '',
            serviceTypeIDs: '',
            object_code:[],
            communicationIdIds:'',
            industryCategoryIds:'',
            cardTypeIDs:'',
            traCurrencyIDs:'',
            issuHomeCurrIDs:'',
            txnissuerIDs:'',
            is_current_date: 'yes'
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, 'dcc_transaction');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }
    componentDidUpdate() {

    }

    componentDidMount() {
        this._get_filtered_dcc_transaction_report(this.state.object_type,this.state.object_code,'');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'dcc_txn_report','sparcs')
    }

    _get_filtered_dcc_transaction_report(object_type, object_code, event) {
        var that = this;
        var corCol = 'Merchant';
        var ufeCol = 'Merchant';
        if(that.state.txnTypeIDs.includes("FAILED")===true || that.state.txnTypeIDs.includes("all")===true) {
            corCol = 'Co Reason Message';
            ufeCol = 'Ufe Message';
        }
        var pos_order_id = 'Merchant';
        var grab_order_id = 'Merchant';
        var grab_client_id = 'Merchant';
        var pos_merchant = 'Merchant';
        if(that.state.is_posbillinput==1){
            grab_order_id = 'Grab Order ID';
            pos_order_id = 'Pos Order ID';
            grab_client_id = 'Grab Client ID';
            pos_merchant = 'Pos Merchant ID';
        }

        //isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        var yestSend = date_config1.start_date_value;
        var todSend = date_config1.end_date_value;
        if(this.state.is_current_date=='no') {
            yestSend = this.state.yestSend;
            todSend = this.state.todSend;
        }
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            fr: this.state.frequency,
            yestSend: yestSend,
            todSend: todSend,
            is_void: this.state.is_void,
            txn_type: 'DCC',
            card_grade: this.state.cardGradeIDs,
            scheme: this.state.schemeIDs,
            credit_debit: this.state.cardTypeIDs,
            tra_cuurency: this.state.traCurrencyIDs,
            issuer_home_curr: this.state.issuHomeCurrIDs,
            transaction_type: this.state.txnTypeIDs,
            utid: this.state.ciutidIds,
            is_settled: this.state.isSettledIDs,
            issuer: this.state.txnissuerIDs,
            is_posbillinput: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            industry_code: this.state.industryCategoryIds,
            is_current_date: this.state.is_current_date
        };
        if ($.fn.DataTable.isDataTable('#DccTraTable')) {
            $('#DccTraTable').DataTable().clear().destroy();
        }
        DccTraTable = $('#DccTraTable').DataTable(
            {
                order: [],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo": false,
                // "autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 - 1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/transaction-reports",
                    type: "POST",
                    data: postData,
                    dataSrc: function (json) {
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function (request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [
                    {"data":"Merchant",  "width": "150px",},
                    {"data":"Chain",  "width": "100px",},
                    {"data": "Store Name", "width": "100px",},
                    {"data":"Store Address 1", "width": "100px"},
                    {"data":"Store Address 2", "width": "100px"},
                    {"data": "City"},
                    {"data": "Date"},

                    {"data": "Issuer Bank"},
                    {"data": "Issuer Home Currency"},
                    {"data": "Exchange Rate"},
                    {"data": "Transaction Currency"},
                    {"data": "Transaction Amount"},
                    {"data": "Settlement Amount (INR)"},
                    {"data": "echargeslip_url"},
                    {"data": "Btid"},
                    {"data": "Utid"},
                    {"data": "Card Number"},
                    {"data": "Acquirer Bank"},
                    {"data": "Scheme"},
                    {"data": "Card Grade"},
                    {"data": "Card Type"},
                    {"data": "RRN No"},
                    {"data": "Approval Code"},
                    {"data": "Merchant Id"},
                    {"data": "Merchant Invoice Number"},
                    {"data": "Batchsrl"},
                    {"data": "Invoice"},
                    {"data": "Bank Merchant Id"},
                    {"data": "Cashier ID"},
                    {"data": "Transaction Type"},
                    {"data": "Card Holder Name"},
                    {"data": "Processing Code"},
                    {"data": "Mark up %"},
                    {"data":"Settlement Date"},
                    {"data":"Settled/Unsettled"},
                    {"data":corCol},
                    {"data":ufeCol},
                    {"data":grab_order_id },
                    {"data":pos_order_id },
                    {"data":grab_client_id },
                    {"data":pos_merchant },
                    {"data":"prim_id" },
                    {"data":"parent_prim_id"},
                    {"data":"State"},
                    {"data": "Logo"},
                    {"data":"Industry Category"}

                ],
                "columnDefs": [

                    {  render: function (data) {
                            return '<td >' + moment(data).format('D MMM YYYY HH:mm:ss') + '</td>';
                        },
                        "width": "80px",
                        "targets": 6,

                    },
                    {
                        width: "130px",
                        targets: 11,
                    },
                    {
                        render: function (data, type, row) {
                            var tr_date = moment(row['Date']).format('YYYY-MM-DD')
                            if(row['Settled/Unsettled']==="Failed" || row['Settled/Unsettled']==="FAILED") {
                                return '<td ></td>';
                            }
                            else{
                                return '<td ><a href="#" data-code ="' + data + '" data-trdate ="' + tr_date + '" data-acqbank ="' + row['Acquirer Bank'] + '" data-primid ="' + row['prim_id'] + '">Get Receipt</a> &nbsp;</td>';
                            }
                        },
                        className: "charge_slip",
                        targets: 13,
                        aTargets: [-1]
                    },
                    {
                        width: "130px",
                        targets: 28,
                    },
                ]

            });
        if(that.state.txnTypeIDs.includes("FAILED")===true || that.state.txnTypeIDs.includes("all")===true) {
            //DccTraTable.columns(13).visible(false);
            DccTraTable.columns(35).visible(true);
            DccTraTable.columns(36).visible(true);
        } else {
            //DccTraTable.columns(13).visible(true);
            DccTraTable.columns(35).visible(false);
            DccTraTable.columns(36).visible(false);
        }
        if(that.state.is_posbillinput===1) {
            DccTraTable.columns(37).visible(true);
            DccTraTable.columns(38).visible(true);
            DccTraTable.columns(39).visible(true);
            DccTraTable.columns(40).visible(true);
        } else {
            DccTraTable.columns(37).visible(false);
            DccTraTable.columns(38).visible(false);
            DccTraTable.columns(39).visible(false);
            DccTraTable.columns(40).visible(false);
        }
        if(that.state.is_prim_id===1) {
            DccTraTable.columns(41).visible(true);
            if(that.state.txnTypeIDs.includes("REVERSAL")===true || that.state.txnTypeIDs.includes("VOID")===true || that.state.txnTypeIDs.includes("FAILED")===true|| that.state.txnTypeIDs.includes("all")===true) {
                DccTraTable.columns(42).visible(true);
            } else {
                DccTraTable.columns(42).visible(false);
            }
        } else {
            DccTraTable.columns(41).visible(false);
            DccTraTable.columns(42).visible(false);
        }
        $('#DccTraTable').on('click', 'td.charge_slip a', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var code = $(this).data("code");
            var acqbank = $(this).data("acqbank");
            var trdate = $(this).data("trdate");
            var prim_id = $(this).data("primid");
            let win=window.open('about:blank','popUpWindow', 'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes' )
            var perLoad = '<div style="text-align: center" id="loaderDiv"><img src=" '+ loadingGif +' "></div>';
            win.document.write(perLoad)
            $.ajax({
                url:config.get('API_URL')+ "/reports/generate_slip/?code="+code+"&acq_bank_name="+acqbank+"&transaction_date="+trdate+"&prim_id="+prim_id,
                type: 'GET',

                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                success: function (response) {
                    win.document.close();
                    win.document.write(response)

               },
               //dataType: 'html'
            })
         })
    }


    transactionReportDownloadCheck(){
        let transaction_type = this.state.txnTypeIDs;
        if (Array.isArray(this.state.txnTypeIDs) && this.state.txnTypeIDs.includes("all") === true) {
            transaction_type = ""
        }
        var yestSend = date_config1.start_date_value;
        var todSend = date_config1.end_date_value;
        if(this.state.is_current_date=='no') {
            yestSend = this.state.yestSend;
            todSend = this.state.todSend;
        }
        let filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            utid: this.state.ciutidIds,
            acq_bank_codes: this.state.acqBankIds,
            city: this.state.cityIds,
            transaction_type: transaction_type,
            settlement_status: this.state.isSettledIDs,
            show_pos_bill_input_columns: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            start_date: yestSend,
            end_date: todSend,
            show_void_transactions: this.state.is_void,
            txn_type: 'DCC',
            category_code: this.state.industryCategoryIds,
            download: 1,
            gst_columns: 0,
            card_grade: this.state.cardGradeIDs,
            card_type: this.state.schemeIDs,
            credit_debit: this.state.cardTypeIDs,
            txn_currency: this.state.traCurrencyIDs,
            home_currency: this.state.issuHomeCurrIDs,
            issuer_bank: this.state.txnissuerIDs,
            user_type: this.state.userType,
            report_code:"dcc_txn_report",
            user_id: this.state.user_id,
            is_current_date: this.state.is_current_date
        }
        this.setState({
            filters:filters
        })
        let is_txn = false;
        if(this.state.txnTypeIDs.length===1 && this.state.txnTypeIDs[0]==='SALE')
        {
           is_txn = true;
        }
        if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds==='' && this.state.acqBankIds===''
        && this.state.cityIds==='' && this.state.traCurrencyIDs==='' && this.state.txnissuerIDs==='' && this.state.schemeIDs===''
        && this.state.cardTypeIDs==='' && this.state.isSettledIDs==='' && this.state.issuHomeCurrIDs==='' && is_txn ===true
        ){
          confirmAlert({
                //title: 'Warning',
                message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.refs.downloadAllReport.downLoadReport(filters, '/report/transaction/daily/categories','dcc_transaction_report');
                    }
                },
                    {
                        label: 'Cancel',
                    }
                ]
            });
            } else {
                this.refs.downloadAllReport.downLoadReport(filters, '/report/transaction/daily/categories','dcc_transaction_report');
            }
    }

    reset_all(e){
        if(this.state.is_current_date=='no'){
            this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        }
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }
        this.refs.cityFilter.resetCityFilter();
        this.refs.acquirerFilter.resetAcquirerFilter();
        this.refs.reloadTxnIssuer._txn_issuer_bank(date_config.start_date_value, date_config.end_date_value);
        this.refs.schemeFilter.resetScheme();
        this.refs.txnTypeFilter.resetTxnTypeFilter();
        this.refs.settledFilter.resetSettledFilter();
        this.refs.cardTypeFilter._get_card_type(date_config.start_date_value, date_config.end_date_value);
        this.refs.txnCurrencyFilter._get_txn_curr(date_config.start_date_value, date_config.end_date_value);
        this.refs.homeCurrencyFilter._get_home_curr(date_config.start_date_value, date_config.end_date_value);
        this.refs.industryCategoryFilter.resetIndustryCategoryFilter();
        this.refs.posbillFilter.resetPosbillFilter();
        this.refs.primIdFilter.resetPrimIdFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            cardGradeValue:[],
            cardGradeIDs:'',
            schemeValue:[],
            schemeIDs:'',
            cardTypeValue:[],
            cardTypeIDs:'',
            txnissuerValue:[],
            txnissuerIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidValue: [],
            ciutidIds: '',
            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            tenderModeIDs:'',
            tenderModeValue:[],
            is_fallback: 0,
            traCurrencyValue:[],
            traCurrencyIDs:'',
            issuHomeCurrValue:[],
            issuHomeCurrIDs:'',
            industryCategoryIds:'',
            industryCategoryValue: [],
            is_current_date: 'yes'
        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
     handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
        this.refs.reloadTxnIssuer._txn_issuer_bank(yestSend, todSend);
        this.refs.cardTypeFilter._get_card_type(yestSend, todSend);
        this.refs.txnCurrencyFilter._get_txn_curr(yestSend, todSend);
        this.refs.homeCurrencyFilter._get_home_curr(yestSend, todSend);

    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }

    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }
    handleTxnIssuer = (optionSelected, issuArray) =>
    {
        this.setState({
            txnissuerIDs:issuArray,
            isChange: true
        });
    }
    handleCity = (optionSelected, cityIds) =>
    {
        this.setState({
            cityIds:cityIds,
            isChange: true
        });
    }
    handleTxnType = (optionSelected, txnTypeIDs) =>
    {
        this.setState({
            txnTypeIDs:txnTypeIDs,
            isChange: true
        });
    }
    handleScheme = (optionSelected, schemeArray) =>
    {
        this.setState({
            schemeIDs:schemeArray,
            isChange: true
        });
    }
    handleCardType = (optionSelected, ceditArray) =>
    {
        this.setState({
            cardTypeIDs:ceditArray,
            isChange: true
        });
    }
    handleTxnCurrency = (optionSelected, traCurrArray) =>
    {
        this.setState({
            traCurrencyIDs:traCurrArray,
            isChange: true
        });
    }
    handleHomeCurrency = (optionSelected, homeCurrArray) =>
    {
        this.setState({
            issuHomeCurrIDs:homeCurrArray,
            isChange: true
        });
    }
    handleSettled = (optionSelected, isSettledIDs) =>
    {
        this.setState({
            isSettledIDs:isSettledIDs,
            isChange: true
        });
    }
    handleIndustryCategoryFilter = (optionSelected, industryCategoryIds) =>
    {
        this.setState({
            industryCategoryIds:industryCategoryIds,
            isChange: true
        });
    }
    handlePosBill = (is_posbillinput) => {
        this.setState({is_posbillinput: is_posbillinput, isChange: true});
    }
    handlePrimId = (is_prim_id) => {
        this.setState({is_prim_id: is_prim_id, isChange: true});
    }
    onDateTypeChanged = e => {
        const {name, value} = e.target;
        this.setState({
            [name]: value,
            isChange: true,

        });

    }
    render() {
        return (
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">DCC Transaction Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="content" style={{ padding: '0px 15px 10px 15px' }}>
                                    <div className="row">
                                        <div className="col-md-10 filter-border-right">
                                            <div>
                                                <label><input type="radio" name="is_current_date"
                                                                   value="yes"
                                                                   checked={this.state.is_current_date === 'yes'}
                                                                   onChange={this.onDateTypeChanged} /> Current Date
                                                                   &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" name="is_current_date"
                                                                   value="no"
                                                                   checked={this.state.is_current_date === 'no'}
                                                                   onChange={this.onDateTypeChanged} /> Previous Date</label>

                                                </div>
                                                <div className="clearfix"></div>
                                                {this.state.is_current_date==='no'?
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>:null}
                                            {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            {/*{this.state.acq_bank_list_box===true?*/}
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Acquirer:</label>
                                                <AcquirerFilter ref="acquirerFilter" onSelectAcquirer = {this.handleAcquirer}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            {/*: null }*/}
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Issuer:</label>
                                                <TxnIssuerFilter ref= "reloadTxnIssuer" onSelectTxnIssuer = {this.handleTxnIssuer} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> City: </label>
                                                <CityFilter ref="cityFilter" onSelectCity = {this.handleCity}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Txn Type </label>
                                                <TxnTypeFilter ref="txnTypeFilter" onSelectTxnType = {this.handleTxnType} is_upi_leg1 = 'No' />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Scheme: </label>
                                                <SchemeFilter ref= "schemeFilter" onSelectScheme = {this.handleScheme} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Card Type: </label>
                                                <CardTypeFilter ref= "cardTypeFilter" onSelectCardType = {this.handleCardType} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Transaction Currency: </label>
                                                <TxnCurrencyFilter ref= "txnCurrencyFilter" onSelectTxnCurr = {this.handleTxnCurrency} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Issuer Home Currency: </label>
                                                <HomeCurrencyFilter ref= "homeCurrencyFilter" onSelectHomeCurr = {this.handleHomeCurrency} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Settled/Unsettled: </label>
                                                <SettledUnsettledFilter ref="settledFilter" onSelectSettled = {this.handleSettled}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Industry Category: </label>
                                                <IndustryCategoryFilter ref="industryCategoryFilter" onSelectIndustryCategoryFilter = {this.handleIndustryCategoryFilter}/>
                                                <div className="clearfix"></div>
                                            </div>
                                        </div>
                                        <div className="col-md-2 filter-bottom5 ">
                                            <div>
                                                <PosbillFilter ref="posbillFilter" onSelectPosbill = {this.handlePosBill} />
                                            </div>
                                            <div>
                                                <PrimIdFilter ref="primIdFilter" onSelectPrimId = {this.handlePrimId} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                        <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this._get_filtered_dcc_transaction_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                    </div>
                                    </div>


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button"
                                           onClick={this.transactionReportDownloadCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div
                                        className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="DccTraTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th width="150px">Merchant</th>
                                                <th width="100px">Chain</th>
                                                <th width="100px">Store Name</th>
                                                <th width="100px">Store Address 1</th>
                                                <th width="100px">Store Address 2</th>
                                                <th>City</th>
                                                <th>Transaction Date</th>

                                                <th>Issuer Bank</th>
                                                <th>Issuer Home Currency</th>
                                                <th>Exchange Rate</th>
                                                <th>Transaction Currency</th>
                                                <th>Transaction Amount</th>
                                                <th>Settlement Amount (INR)</th>
                                                <th>Digital Chargeslip</th>
                                                <th>Btid</th>
                                                <th>Utid</th>
                                                <th>Card Number</th>
                                                <th>Acquirer Bank</th>
                                                <th>Scheme</th>
                                                <th>Card Grade</th>
                                                <th>Card Type</th>
                                                <th>RRN No</th>
                                                <th>Approval Code</th>
                                                <th>Merchant Id</th>
                                                <th>Merchant Invoice Number</th>
                                                <th>Batchsrl</th>
                                                <th>Invoice</th>
                                                <th>Bank Merchant Id</th>
                                                <th>Cashier ID</th>
                                                <th>Transaction Type</th>
                                                <th>Card Holder Name</th>
                                                <th>Processing Code</th>
                                                <th>Mark up %</th>
                                                <th>Settlement Date</th>
                                                <th>Settled/Unsettled</th>
                                                <th>Co Reason Message</th>
                                                <th width="150">Ufe Message</th>
                                                <th>Grab Order ID</th>
                                                <th>Pos Order ID</th>
                                                <th>Grab Client ID</th>
                                                <th>Pos Merchant ID</th>
                                                <th>Prim ID</th>
                                                <th>Parent Prim ID</th>
                                                <th>State</th>
                                                <th>Logo</th>
                                                <th>Industry Category</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <SingleCsvReportDownload ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( DccTransactionReport)